import { render, staticRenderFns } from "./PlaceTutorial.vue?vue&type=template&id=044875ea&"
import script from "./PlaceTutorial.vue?vue&type=script&lang=js&"
export * from "./PlaceTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports